<template>
  <div class="upload">
    <div class="upload_content">
            <span class="img_box" v-for="(src,index) in imgDatas" :key="index">
                <!-- <van-icon name="cross" class="delete" /> -->
                <img :src="src.imgUrl" class="upload_img" :style="src.img">
            </span>
    </div>
    <div class="up_title">上传图片</div>
    <div class="van-uploader">
      <div class="van-uploader__wrapper">
        <div v-if="upload" @click="chooseImage" class="van-uploader__upload">
          <van-icon class="van-icon van-icon-plus van-uploader__upload-icon" name="plus" />
          <input multiple="multiple" accept="image/*" class="van-uploader__input" type="flie">
        </div>
      </div>
    </div>




    <van-popup class="back_img" v-model="show">

      <div class="wrapper" @click.stop>
        <div class="cropper-component">
          <div class="info-item">
            <div class="operation-box">
              <div class="cropper">
                <vueCropper
                  ref="cropper"
                  :img="option.img"
                  :outputSize="option.size"
                  :outputType="option.outputType"
                  :info="option.info"
                  :full="option.full"
                  :canMove="option.canMove"
                  :canMoveBox="option.canMoveBox"
                  :original="option.original"
                  :autoCrop="option.autoCrop"
                  :autoCropWidth="option.autoCropWidth"
                  :autoCropHeight="option.autoCropHeight"
                  :fixedBox="option.fixedBox"
                ></vueCropper>
              </div>
            </div>
          </div>
        </div>

        <p class="tips">图片尺寸应为：w320*h240</p>

        <img class="rotate" @click="rotate" src="../assets/icon-xuanzhuan@2x.png">

        <div class="aline"></div>

        <div class="button">
          <span @click="cancel">取消</span>
          <span @click="confirm">确认</span>
        </div>
      </div>

    </van-popup>

  </div>
</template>

<script>
  import Vue from 'vue';
  import { Uploader } from 'vant';
  import { Popup } from 'vant';
  import { Toast } from 'vant';
  import wx from 'weixin-js-sdk';
  import { Icon } from 'vant';
  import { Dialog } from 'vant';
  import { Image } from 'vant';
  import { Overlay } from 'vant';

  Vue.use(Overlay);
  Vue.use(Image);
  Vue.use(Icon);
  Vue.use(Toast);
  Vue.use(Popup);
  Vue.use(Uploader);

  export default {
    name: 'cropper',
    data() {
      return {
        instrumentid : '',
        imgDatas: [],
        isIOS: '',  // ios
        isAndroid: '',  // 安卓
        imageUrlList: [],   // 图片预览的数组
        suggestionimgs: [],
        result: [],
        upload: true,
        xImg:'',
        yImg:'',

        backImg: '',
        show: false,

        //剪切图片上传
        crap: false,
        option: {
          img: '', // 裁剪图片的地址
          info: true, // 裁剪框的大小信息
          outputSize: 0.8, // 剪切后的图片质量（0.1-1）
          full: true, // 输出原图比例截图 props名full
          outputType: 'png', // 裁剪生成额图片的格式
          canMove: true,  // 能否拖动图片
          original: false,  // 上传图片是否显示原始宽高
          canMoveBox: true,  // 能否拖动截图框
          autoCrop: true, // 是否默认生成截图框
          autoCropWidth: 320,
          autoCropHeight: 240,
          centerBoxs: false,
          canScale: true,
          fixedBox: true // 截图框固定大小
        },
        fileName:'',  // 本机文件地址
      };
    },
    created() {
      this.isAndroidFun()
      this.instrumentid = this.$route.params.id
      this.getImgData()
      window.vue_image = this
    },
    mounted() {
      this.axios.get('/weixin/wxJsSdkConfig',{
        params: {
          url : location.href.split('#')[0]
        }
      }).then((res)=>{
        wx.config({
          debug: false, // 开启调试模式,
          appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature,// 必填，签名，见附录1
          jsApiList: ['chooseImage','uploadImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
      }),

        wx.ready(function() {
          wx.checkJsApi({
            jsApiList : [ 'openWXDeviceLib', 'closeWXDeviceLib','chooseImage','uploadImage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success : function(res) {
            }
          });
          wx.invoke('openWXDeviceLib', {
            'connType' : 'lan'

          }, function(res) {
          });

        });
    },
    methods: {
      getImgData() {
        this.axios.get('/weixin/getInstrumentimgs',{
          params: {
            instrumentid: this.instrumentid
          }
        })
          .then(res=>{
            for(let i = 0; i <= this.imgDatas.length; i++) {
              this.imgDatas.push({ imgUrl: `/img/instrumentimg/${res.data[i].instrumentimgurl}.png` })

            }
          })
      },

      chooseImage(e) {
        let self = this;
        wx.chooseImage({
          count: 1,
          sizeType: ['original', 'compressed'],
          sourceType: ['album', 'camera'],
          success: function (res) {


            var localIds = res.localIds

            for (var i = 0; i < localIds.length; i++) {
              wx.getLocalImgData({
                localId:res.localIds[i],
                success: function (res){
                  console.log(res);
                  var localData = res.localData;
                  if(self.isIOS) {    //ios
                    localData = localData.replace('jgp', 'jpeg');
                  }
                  if(self.isAndroid) {    // 安卓
                    localData.replace(/\r|\n/g,'').replace('data:image/jgp','data:image/jpeg');
                    localData = 'data:image/jpeg;base64,'+localData;

                  }
                  self.option.img = localData;

                }
              })

              // 图片上传
              wx.uploadImage({

                localId: res.localIds[i],
                isShowProgressTips: 1,
                success: function (res) {

                  // alert(res);
                  // do something
                  self.suggestionimgs.push(res.serverId)
                  self.option.img = `/weixin/tupian/getImage?serverId=${res.serverId}`
                  self.show = true


                  // 将图片上传到后台

                }
              });
            }
          }
        });
      },

      // 判断ios还是安卓
      isAndroidFun() {
        var u = navigator.userAgent
        var app = navigator.appVersion
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if(isAndroid) {
          this.isAndroid = true;
        }else if(isiOS) {
          this.isIOS = true;
        }
      },
      // 删除图片
      delete_img() {
        this.imageUrlList.splice(-1,1)
        if(this.imageUrlList.length != 3) {
          this.upload = true
        }
      },

      cancel() {
        this.show = false
      },



      confirm() {

        //  var img=this.$refs.cropper.getImgAxis();//图片坐标
        // var crop=this.$refs.cropper.getCropAxis();//框坐标
        this.xImg=Math.round(this.$refs.cropper.getCropAxis().x1);
        this.yImg =Math.round(this.$refs.cropper.getCropAxis().y1);


       // debugger;
          this.$refs.cropper.getCropData((data) => {//图片截取后的数据
           // debugger;
            const file = new File([data], 'avatar.jpg', {
              type: 'image/jpeg',
            })

            this.axios.post('/weixin/instrumentImg2',{
              data: {
                file:file,
              },
            })
              .then(res=>{

                res.data.fileName
              })
          })


        this.axios.get('/weixin/tempInstrumentImg', {
          params: {
            temp: this.suggestionimgs[0],
            instrumentid: this.instrumentid
          }
        })
          .then(res=>{
            this.backImg = res.data.temp
            this.$refs.cropper.getCropData((data) => {
              this.imgDatas.push({imgUrl: data})
            })
            this.show = false


            //上传图片-替换图片
            this.axios.get('/weixin/uploadInstrumentImg',{
              params: {
                x: this.xImg,
                y: this.yImg,
                w: this.$refs.cropper.cropW,//320,
                h: this.$refs.cropper.cropH,//240,
                temp: res.data.temp,
                instrumentid: res.data.instrumentid
              }
            })
              .then(res=>{
                // this.getImgData()
              })
          })
          .catch(res=>{

          })
        //  })
        //上传临时图片


      },

      rotate() {
        this.$refs.cropper.rotateRight()
      },
    }
  };



</script>
<style>
  /* .cropper-box {
      overflow: visible!important;
  }
  .cropper-view-box {
      overflow: visible!important;
  } */
  .operation-box {
    margin: 0 auto;
  }
</style>

<style scoped>
  .van-uploader {display: block}
  .van-icon, .van-icon::before {
    display: inline-block;
  }
  .van-uploader__upload {
    width: 30%;
    height: 240px;
  }
  .van-uploader__upload-icon {
    font-size: 120px;
    color: #ccc;
  }
  .van-popup {
    background: none;
  }
  .weui-uploader__files{list-style:none}

  .weui-uploader__hd{display:-webkit-box;display:-webkit-flex;display:flex;padding-bottom:10px;-webkit-box-align:center;-webkit-align-items:center;align-items:center}

  .weui-uploader__title{-webkit-box-flex:1;-webkit-flex:1;flex:1}
  .weui-uploader__info{color:#b2b2b2}

  .weui-uploader__bd{margin-bottom:-4px;margin-right:-9px;overflow:hidden}

  .weui-uploader__input-box{float:left;position:relative;margin-right:9px;margin-bottom:9px;width:146px;height:146px;border:1px solid #d9d9d9}
  .weui-uploader__input-box:after,.weui-uploader__input-box:before{content:" ";position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);background-color:#d9d9d9}
  .weui-uploader__input-box:before{width:4px;height:72px}
  .weui-uploader__input-box:after{width:72px;height:2px}
  .weui-uploader__input-box:active{border-color:#999}
  .weui-uploader__input-box:active:after,
  .weui-uploader__input-box:active:before{background-color:#999}

  .pic_cut {
    width: 100%;
    height: 100%;
  }


  .upload {
    padding: 30px;
  }

  .upload_content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .upload_content:after{
    content: '';
    width: 30%;
    border: 2px solid transparent;
  }

  .img_box {
    position: relative;
    display: inline-block;
    width:30%;
    height: 240px;
    background: #fff;
    border: 2px solid #ccc;
    margin-bottom: 44px;
    text-align: center;
    line-height: 300px;
  }
  .upload_img {
    width: 100%;
    height: 100%;
  }

  .up_title {
    margin-bottom: 40px;
  }


  .delete {
    position: absolute;
    top: -14px;
    right: -18px;
    z-index: 1;
    color: #ccc;
    background: #fff;
    border-radius: 50%;
  }



  .cropper {
    width: 900px;
    height: 900px;
  }

  .vue-cropper {
    background-image: none;
  }

  /*.back_img {
      width: 100%;
      height: 100%;
      padding-top: 60%;
      text-align: center;
  }*/
  .back_img{
    width: 90%;
    height: 100%;
    display: flex;
    justify-content: center;
  }
  .wrapper {
    display: flex;
    flex-direction: column;/*主轴 左:row, 右：row-reverse, 列：column*/
    justify-content: center;

  }
  .cropper-component {
    flex-basis: 500px;


  }



  /*
  .wrapper {
        text-align: left;
        position: relative;
  }*/

  .rotate {
    margin-left: 100px;
    margin-top: 100px;
    position: absolute;
    width: 90px;
  }

  .aline {
    width: 100%;
    height: 2px;
    position: absolute;
    bottom: -80px;
    background-color:#8c8c8c;
  }
  .button {
    /*  position: relative;*/
    bottom: -240px;
    padding: 0 100px;
    display: flex;
    color: #7cd393;
    justify-content:space-between;
  }

  .button span {
    font-size: 50px;
  }
  .tips {
    text-align: center;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/views/UploadImg.vue